import { render, staticRenderFns } from "./RollObject.vue?vue&type=template&id=5ad9cb62&scoped=true&"
import script from "./RollObject.vue?vue&type=script&lang=ts&"
export * from "./RollObject.vue?vue&type=script&lang=ts&"
import style0 from "./RollObject.vue?vue&type=style&index=0&id=5ad9cb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9cb62",
  null
  
)

export default component.exports